export default __webpack_public_path__ + "static/media/Toi-White 1.1f8ac373.svg";